import { render, staticRenderFns } from "./GroupInstructors.vue?vue&type=template&id=caee56cc&"
import script from "./GroupInstructors.vue?vue&type=script&lang=ts&"
export * from "./GroupInstructors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports